export default {
      id: "ic-plan-travaux-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-travaux-usage",
      toString: function () {
        return this.url;
      }
    }